module.exports = __webpack_public_path__ + "img/password.d5a83025.svg";